module.exports = __webpack_public_path__ + "static/media/apm.8a86a1a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/apm.svg
// module id = 188
// module chunks = 0